export enum MessageType {
  Text = 'entity-message',
  LlmThinking = 'thinking',
  LlmToolUsed = 'tool-call',
  Call = 'call',
  TextToSpeech = 'text-to-speech',
}
